import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { LogoutButton } from '@/components/auth/LogoutButton';

interface OnboardingLayoutProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export function OnboardingLayout({ title, description, children }: OnboardingLayoutProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <LogoutButton />
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent>
          {children}
        </CardContent>
      </Card>
    </div>
  );
}